import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import React, { useContext } from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import ButtonMain from "../../../../../../../../../common/components/button/ButtonMain";
import { isEmpty } from "../../../../../../../../../common/utils";
import { StoreContext } from "../../../../../../../../../store/StoreProvider";
import CustomStepper from "../customStepper/CustomStepper";

const CustomExpandBtn = ({ open, setOpen }) => {
  const [state, _] = useContext(StoreContext);
  const { digitalAI } = state;
  const { ocrImgList } = digitalAI;

  const intl = useIntl();

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <ButtonMain
      buttonProps={{
        size: "small",
        fullWidth: true,
        disabled: isEmpty(ocrImgList),
        disableRipple: true, // 取消點擊效果
        variant: "hoverText",
        text: intl.formatMessage({
          id: open
            ? "sna.sidetool.digitalAITool.ocr.expandLess"
            : "sna.sidetool.digitalAITool.ocr.expandMore",
          defaultMessage: open ? "展開" : "收起",
        }),
        endIcon: open ? (
          <ArrowDropUpRoundedIcon />
        ) : (
          <ArrowDropDownRoundedIcon />
        ),
        onClick: handleClick,
      }}
    />
  );
};

CustomExpandBtn.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};

CustomExpandBtn.defaultProps = {
  open: false,
  setOpen: () => null,
};

export default CustomExpandBtn;
